module.exports = __webpack_public_path__ + "img/btn_right.6dc4a1b2.svg";